import { ensureDefined } from '@avantia/client-and-server-utilities';
import { createControlId } from '@avantia/questionset-model';
import { HpSvgIconTypes, SvgIcon } from '@avantia/style-guide';
import { HelpWidget, InfoWidget } from '../../../engineClient/components/widgets/helpInfoWidget';
import { HpInputControlProps } from '../../../engineClient/types';
import { HpClaimsAlertCustomData, HpCoverAlertPageDetails } from '../../../types/alertTypes';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { WarningWidget } from './coverSummaryCustomControl';

interface AlertCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
  customData: HpClaimsAlertCustomData;
}

export const hpClaimsAlertControlClass = 'hp-claims-alert';
export function AlertCustomControl(props: AlertCustomControlProps): JSX.Element | null {
  const { data, value, id } = props;
  const answerValue = value as string;
  const { customData } = data;
  ensureDefined(customData, 'customData');
  const { type, title } = customData as unknown as HpClaimsAlertCustomData;
  let alertElement: JSX.Element | null = null;
  if (answerValue) {
    switch (type) {
      case 'info':
        alertElement = <InfoWidget infoText={answerValue} />;
        break;
      case 'warning':
        alertElement = <WarningWidget warningText={answerValue} warningHeader={title} />;
        break;
      case 'page': {
        const { heading, text } = JSON.parse(answerValue) as HpCoverAlertPageDetails;
        alertElement = <CoverAlertPage title={title || ''} alertHeading={heading} alertText={text} />;
        break;
      }

      default:
        alertElement = <HelpWidget helpText={answerValue} />;
        break;
    }

    return (
      <div className={`hp-standard form-group ${hpClaimsAlertControlClass}`} id={createControlId({ questionId: id })}>
        {alertElement}
      </div>
    );
  }

  return null;
}

function CoverAlertPage({
  title,
  alertHeading,
  alertText
}: {
  title: string;
  alertHeading: string;
  alertText: string;
}): JSX.Element {
  return (
    <div className="av-card alert-page">
      <div>
        <SvgIcon type={'alert-comment' as HpSvgIconTypes} />
        <h3>{title}</h3>
      </div>

      <div>
        <span>
          <strong>{alertHeading}</strong>
        </span>
        <div>{alertText}</div>
      </div>
    </div>
  );
}
